import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { selectors as rootSelectors } from '../root';
import DateForm from './components/form/main';
import moment from 'moment';

import Table from './components/table/main';
import PageContainer from '../shared/page-container/main';
import Filters from '../shared/filters/main';

const tabs = [
	{
		href: '/affiliate-managers-productivity/teams',
		name: 'Teams',
		permission: null
	},
	{
		href: '/affiliate-managers-productivity/individual',
		name: 'Individual',
		permission: null
	}
];

const Main = renderViewsState(
	props => (
		<Animate>
			<PageContainer name='Productivity list' tabs={tabs} >
				<div className="container__content affiliate-managers-productivity">
					<div className="affiliates-list__filter-position clearfix">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="container__content-body">
						<DateForm {...props} initialValues={{date: moment()}}/>
						<div className="affiliates-redeem__table-position">
							<Table {...props}/>
						</div>
					</div>
				</div>
			</PageContainer>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		can: selectors.getCan(state),
		sort: selectors.getSort(state),
		data: selectors.getData(state),
		calendar: selectors.getCalendar(state),
		columns: selectors.getColumns(state),
		filters: selectors.getFilters(state),
		columnGroups: selectors.getColumnGroups(state),
		intl: selectors.getIntl(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliate-managers-productivity/main.js